import { Button, Flex, useToast } from '@chakra-ui/react';
import useToastError from 'hooks/shared/useToastError';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import AlertModal from 'presentation/components/shared/modals/AlertModal';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCancelSelfIpoApplicationMutation } from 'rtkQuery/sharespro/queries/selfIpo';

interface Props {
  applicationId: ID;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const CancelSelfIpoApplicationModal: FC<Props> = ({
  applicationId,
  isOpen,
  onClose,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const toast = useToast();
  const toastError = useToastError();
  const [cancelApplication, { isLoading }] =
    useCancelSelfIpoApplicationMutation();

  return (
    <>
      <AlertModal
        title={t('attention')}
        text={t('selfIpoCancelConfirmation')}
        isOpen={isOpen}
        onClose={onClose}
        footer={
          <Flex>
            <Button mr={3} size="sm" onClick={onClose}>
              {t('back')}
            </Button>
            <Button
              size="sm"
              onClick={() => {
                onClose();
                cancelApplication({ application_id: applicationId })
                  .unwrap()
                  .then(() => {
                    toast({
                      description: t('selfIpoCancelSuccess'),
                      status: 'success',
                      position: 'top-right',
                      isClosable: true,
                    });
                    onSuccess();
                  })
                  .catch(toastError);
              }}
            >
              {t('confirm')}
            </Button>
          </Flex>
        }
      />
      <FullScreenLoader isLoading={isLoading} />
    </>
  );
};

export default CancelSelfIpoApplicationModal;
